// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyState_wrapper__kFNJS","wrapper__message":"EmptyState_wrapper__message__CRiCo","wrapper__title":"EmptyState_wrapper__title__p93n2"};